import React from "react";
import { createPortal } from "react-dom";
import "./styles.css";
import { material_symbols_info_outline } from "../../../assets/images";

interface AFLConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  message: string;
  title?: string;
  confirmText?: string;
  cancelText?: string;
}

const AFLConfirmationModal: React.FC<AFLConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  message,
  title = "Confirmation Required",
  confirmText = "Confirm",
  cancelText = "Cancel",
}) => {
  if (!isOpen) return null;

  return createPortal(
    <div className="afl-confirm-overlay">
      <div className="afl-confirm-container scale-in">
        <div className="afl-confirm-content">
          <div className="afl-confirm-icon-wrapper">
            <img
              src={material_symbols_info_outline}
              alt="Confirm"
              className="afl-confirm-icon"
            />
          </div>

          <h3 className="afl-confirm-title">{title}</h3>
          <div
            className="afl-confirm-message"
            dangerouslySetInnerHTML={{ __html: message.replace(/\n/g, "<br/>") }}
          ></div>

          <div className="afl-confirm-footer">
            <button className="afl-cancel-btn" onClick={onClose}>
              {cancelText}
            </button>
            <button className="afl-confirm-btn" onClick={onConfirm}>
              {confirmText}
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default AFLConfirmationModal;
